import React from 'react';

/**
 * Factures page — top KPI cards row.
 * Pure presentational. Receives raw amounts already computed in the parent.
 */
export default function FacturesKPICards({ caNet, paid, pending, late, creditTotal }) {
  const items = [
    { label: 'CA net', value: `${caNet.toLocaleString('fr-FR')} €`, color: '#4F46E5' },
    { label: 'Encaissé', value: `${paid.toLocaleString('fr-FR')} €`, color: '#14B8A6' },
    { label: 'En attente', value: `${pending.toLocaleString('fr-FR')} €`, color: '#F59E0B' },
    { label: 'En retard', value: `${late.toLocaleString('fr-FR')} €`, color: '#EF4444' },
    { label: 'Avoirs émis', value: `-${creditTotal.toLocaleString('fr-FR')} €`, color: '#B91C1C' },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-testid="factures-kpi-cards">
      {items.map((s) => (
        <div key={s.label} className="soft-card p-4">
          <div className="text-[12px] text-[#8E8FA5] font-medium">{s.label}</div>
          <div className="text-[22px] font-bold mt-0.5" style={{ color: s.color, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{s.value}</div>
        </div>
      ))}
    </div>
  );
}
